module.exports = __webpack_public_path__ + "img/character2.fdbec83c.png";